module.exports = __webpack_public_path__ + "assets/img/audioPlay.f59ab570.gif";